import { lazy } from 'react';
import { Route, Navigate } from 'react-router-dom';
import { AuthLayout } from '@/layouts/AuthLayout';

const LoginPage = lazy(() => import('@/pages/auth/supplier/LoginPage').then((m) => ({ default: m.LoginPage })));
const RegisterPage = lazy(() =>
  import('@/pages/auth/supplier/RegisterPage').then((m) => ({ default: m.RegisterPage }))
);
const TravelerLoginPage = lazy(() => import('@/pages/auth/traveler/LoginPage').then((m) => ({ default: m.LoginPage })));
const TravelerRegisterPage = lazy(() =>
  import('@/pages/auth/traveler/RegisterPage').then((m) => ({ default: m.RegisterPage }))
);
const TravelerForgotPasswordPage = lazy(() =>
  import('@/pages/auth/traveler/ForgotPasswordPage').then((m) => ({ default: m.ForgotPasswordPage }))
);
const ForgotPasswordPage = lazy(() =>
  import('@/pages/auth/supplier/ForgotPasswordPage').then((m) => ({ default: m.ForgotPasswordPage }))
);
const AuthCallbackPage = lazy(() =>
  import('@/pages/auth/AuthCallbackPage').then((m) => ({ default: m.AuthCallbackPage }))
);
const ResetPasswordPage = lazy(() =>
  import('@/pages/auth/ResetPasswordPage').then((m) => ({ default: m.ResetPasswordPage }))
);
const InviteAcceptPage = lazy(() =>
  import('@/pages/auth/InviteAcceptPage').then((m) => ({ default: m.InviteAcceptPage }))
);
const VerifyEmailPage = lazy(() =>
  import('@/pages/auth/VerifyEmailPage').then((m) => ({ default: m.VerifyEmailPage }))
);

export const authRoutes = (
  <Route element={<AuthLayout />}>
    <Route path="/guest/login" element={<TravelerLoginPage />} />
    <Route path="/guest/register" element={<TravelerRegisterPage />} />
    <Route path="/guest/forgot-password" element={<TravelerForgotPasswordPage />} />
    <Route path="/supplier/login" element={<LoginPage />} />
    <Route path="/supplier/register" element={<RegisterPage />} />
    <Route path="/supplier/forgot-password" element={<ForgotPasswordPage />} />
    <Route path="/accept-invite" element={<InviteAcceptPage />} />
    <Route path="/verify-email" element={<VerifyEmailPage />} />
    <Route path="/reset-password" element={<ResetPasswordPage />} />
    <Route path="/auth/callback" element={<AuthCallbackPage />} />
    <Route path="/login" element={<Navigate to="/guest/login" replace />} />
    <Route path="/register" element={<Navigate to="/guest/register" replace />} />
  </Route>
);
